export function getSalutationName(salutation?: string | null) {
  switch (salutation) {
    case 'MR':
      return 'Herr';
    case 'MRS':
      return 'Frau';
    default:
      return '-';
  }
}
